module.exports = new __parcel__URL__("pvp_draw_icon_label.c60e390a.png").toString();